import { render } from "./ShukkaPage.vue?vue&type=template&id=6b739c26&scoped=true"
import script from "./ShukkaPage.vue?vue&type=script&lang=js"
export * from "./ShukkaPage.vue?vue&type=script&lang=js"

import "./ShukkaPage.vue?vue&type=style&index=0&id=6b739c26&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b739c26"]])

export default __exports__